export default {
  title: 'Kasse',
  labels: {
    login: 'Login und nutze deine gespeicherten Infos und Loyalty Punkte',
    continue_as_guest: 'ODER ALS GAST FORTFAHREN ',
  },
  buttons: {
    login: 'Anmelden um mit Punkten zu zahlen',
    demo_mode: 'Demo Modus',
  },
};
